import React, { useRef, useEffect, useState } from 'react';
import CreativePartnerList from './CreativeList/CreativePartnerList/CreativePartnerList';
import CreativeDesignList from './CreativeList/CreativeDesignList/CreativeDesignList';
import CreativeCommunityHeader from '../Creative-Community/CreativeCommunityHeader/CreativeCommunityHeader';
import CreativeMemberBenefit from '../Creative-Community/CreativeMemberBenefit/CreativeMemberBenefit';
import CreativeGetInspired from '../Creative-Community/CreativeGetInspired/CreativeGetInspired';
import CreativeChallenge from '../Creative-Community/CreativeChallenge/CreativeChallenge';
import CreativeFollow from '../Creative-Community/CreativeFollow/CreativeFollow';
import CreativeInstaList from './CreativeInstaList/CreativeInstaList';
import '../../components/Creative-Community/CreativeCommunity.scss';

const CreativeCommunity = ({data}) => {
  const section3 = useRef(null);
  const section4 = useRef(null);
  const section5 = useRef(null);

  const [isPartnerView, setIsPartnerView] = useState(true);
  const [isCreativeInstaList, setIsCreativeInstaList] = useState(false);

  useEffect(() => {
    document.body.style.backgroundColor = '#9ACCC6';
    return ()=>{
      document.body.style.backgroundColor = '';
    }
  }, [])


  const scrollToContent = (content) => {
    switch (content) {
      case "Explore Community Designs":
        setIsPartnerView(false);
        window.scrollTo({top: section3.current.getBoundingClientRect().top-100, behavior: 'smooth'});
        break;
      case "Find a Creative":
        setIsPartnerView(true);
        window.scrollTo({top: section3.current.getBoundingClientRect().top-100, behavior: 'smooth'});
        break;
      case 'Join The Creative Community':
        window.scrollTo({top: section5.current.getBoundingClientRect().top-150, behavior: 'smooth'});
        break;
      default:
        break;
    }
  }

  const onCreativeChallengeList = () => {
    setIsCreativeInstaList(true);
  }

  return (
    <>
      <div className={`community-creative-container ${isCreativeInstaList ? 'creative-insta-list-page' : ''}`}>
        {
          isCreativeInstaList ? 
            <CreativeInstaList 
              onBackToCommunity={()=>setIsCreativeInstaList(false)} 
            />
          : <>
            <CreativeCommunityHeader scrollToContent={scrollToContent} />
            {isPartnerView && <CreativePartnerList limit={12} ref={section3} />}
            {/* <CreativeDesignList> breaks when selected */}
            {!isPartnerView && <CreativeDesignList limit={12} ref={section3} />}
            <CreativeChallenge 
              onCreativeChallengeList={onCreativeChallengeList} 
              onBackToCommunity={()=>setIsCreativeInstaList(false)} 
            />
            <CreativeGetInspired ref={section4} />
            <CreativeMemberBenefit ref={section5} />
            <CreativeFollow data={data} />
          </>
        }
      </div>
    </>
  )
}

export default CreativeCommunity;